'use strict';

var _require = require('fpx'),
    get = _require.get,
    isFunction = _require.isFunction;

/**
 * Interfaces
 */

exports.isRef = isRef;
function isRef(value) {
  return Boolean(value) && isFunction(value.deref);
}

/**
 * Utils
 */

exports.deref = deref;
function deref(ref) {
  if (isRef(ref)) {
    var value = ref.deref();
    return value === ref ? value : deref(value);
  }
  return ref;
}

exports.derefIn = derefIn;
function derefIn(ref, path) {
  return deref(path.reduce(derefByKey, ref));
}

function derefByKey(cursor, key) {
  if (isRef(cursor)) {
    var value = cursor.deref();
    return (value === cursor ? get : derefByKey)(value, key);
  }
  return get(cursor, key);
}

exports.derefAt = derefAt;
function derefAt(path, ref) {
  return derefIn(ref, path);
}


//////////////////
// WEBPACK FOOTER
// ./~/espo/dist/ref.js
// module id = 377
// module chunks = 118